import { Observable, filter, firstValueFrom, lastValueFrom } from "rxjs";

export function promiseFirst<T>(source:Observable<T>, defaultValue:T){
	return firstValueFrom<T,T>(source,{defaultValue});
}

export function promiseFirstDefined<T>(source:Observable<T>){
	source=source.pipe(filter(v=>v!==undefined));
	return firstValueFrom<T,T|null>(source,{defaultValue:null});
}

export function promiseLast<T>(source:Observable<T>, defaultValue:T){
	return lastValueFrom<T,T>(source,{defaultValue});
}
